import { ACTION_TYPE, REPORT_NAME } from "../../components/constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../redux-toolkit/hooks";
import * as Yup from 'yup';
import { getAllcountryDetail } from "../../redux-toolkit/slices/countrySlice";
import { getFindStateByCountryNameDetail } from "../../redux-toolkit/slices/statesSlice";
import { Modal } from "react-bootstrap";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
    isCategory?: boolean;
    setIsCategory?: any;
};

const validationSchema = Yup.object().shape({
    percentageCompleted: Yup.number()
        .min(0, 'Percentage must be at least 0')
        .max(100, 'Percentage cannot exceed 100'),
});

const MasterReportData = (props: Props) => {

    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");
    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [file, setFile]: any = useState<File | null>(null);
    const [selectData, setSelectData]: any = useState();

    const [activeTab, setActiveTab] = useState<"manual" | "bulk">("manual");

    //save

    //bulk

    //update

    //getById mutation

    //getData

    //Data

    const allCountries: any = useAppSelector(getAllcountryDetail);
    const allStates: any = useAppSelector(getFindStateByCountryNameDetail);

    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            // if (props.reportName === REPORT_NAME.AGENT_MASTER) {

            // }

        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            // if (props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {

            // }
        }
    }, [props.reportName]);

    const handleClose = () => {
        props.setShow(false);
    };

    const handleSubmit = (values: any) => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            // if (props.reportName === REPORT_NAME.AGENT_MASTER) {

            // }
        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            // if (props.reportName === REPORT_NAME.AGENT_MASTER) {

            // }
        }
    };

    const handleBulkUpload = (e: any) => {

        const file = e.target.files[0];

        const fileName = e.target.files[0].name;
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        if (extFile == "xlsx") {
            setFile(e.target.files[0]);
        } else {
            alertMessage("Only xlsx files are allowed!", "error");
        }
    };

    const handleBulkSave = () => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            const formData = new FormData();
            if (file) {
                formData.append('file', file);
            }

            // if (props.reportName === REPORT_NAME.AGENT_MASTER) {

            // }
        }
    }

    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                {...(
                    props.reportName === REPORT_NAME.USER_SUBSCRIBER || props.reportName === REPORT_NAME.USER_GROUP
                        ? { dialogClassName: "modal-90w" }
                        : { size: "lg" }
                )}

            >
                <Modal.Header closeButton>

                    <Modal.Title
                        className="fw-bold text-accent"
                        style={{ fontSize: "1rem" }}
                    >
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {props.reportName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* {bulkSaveResponsibilityGroupResponse.isLoading ||
                            
                            ? (
                            <Loading />
                        ) : (
                            ""
                        )
                    } */}

                    {props.actionType === ACTION_TYPE.ADD_ACTION && (
                        <ul className="nav nav-tabs mb-3" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'manual' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('manual')}
                                >
                                    Manual Entry
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'bulk' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('bulk')}
                                >
                                    Bulk Upload
                                </button>
                            </li>
                        </ul>
                    )}


                    {activeTab === "manual" && (
                        <Formik
                            validationSchema={validationSchema}
                            validateOnChange={true}
                            validateOnBlur={true}
                            enableReinitialize={true}
                            initialValues={{
                                name:
                                    props.actionType === ACTION_TYPE.UPDATE_ACTION
                                        ? getByIdData?.name ?? ""
                                        : "",
                            }}
                    onSubmit={handleSubmit}
                        >
                    {({ values, handleChange, setFieldValue, errors, touched, handleBlur }) => (
                        <Form>
                            <>
                            </>
                            < div className="d-flex flex-row justify-content-center">
                                <button
                                    type="submit"
                                    className={`btn btn-primary btn-block mt-3 mx-2 btn-width bg-accent`}
                                >
                                    {props.actionType === ACTION_TYPE.ADD_ACTION
                                        ? "Save"
                                        : "Update"}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                    onClick={handleClose}
                                >
                                    Close
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
                    )}
                {activeTab === "bulk" && (
                    <div className="border p-3 rounded">
                        <div className="mb-3">
                            <label htmlFor="xlsxUpload" className="form-label">
                                Upload .xlsx File <span className="text-danger">*</span>
                            </label>
                            <input
                                className="form-control"
                                type="file"
                                accept=".xlsx"
                                id="xlsxUpload"
                                onChange={handleBulkUpload}
                            />
                        </div>
                        <a
                            // href={`/templates/${props.reportName === REPORT_NAME.VALUE_CHAIN ? 'VALUE_CHAIN'
                            //     : props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY ? 'VALUE_CHAIN_CATEGORY'
                            //         : props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP ? 'RESPONSIBILITY_GROUP'
                            //             : props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER ? 'RESPONSIBILITY_CENTER'
                            //                 : props.reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER ? 'TOKEN_MECHANISM_MASTER'
                            //                     : ''}.xlsx`}

                            download
                            className="btn btn-outline-secondary"
                        >
                            Download Sample .xlsx Template
                        </a>
                        <button
                            className="btn btn-primary mx-2 bg-accent"
                            onClick={handleBulkSave}
                            disabled={!file}
                        >
                            Save
                        </button>
                    </div>
                )}

            </Modal.Body>
        </Modal >
        </>
    );

};

export default MasterReportData